module.exports = __webpack_public_path__ + "img/Simulation-OutsideWall.f37eab57.jpeg";